"use client";

import { motion } from "framer-motion";

import { cn } from "@/lib/utils";

export function StepPanel({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <motion.div
      className={cn("flex min-h-0 flex-1 flex-col px-5 py-4 sm:px-6", className)}
      initial={{ opacity: 0, x: 10 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -10 }}
      transition={{ duration: 0.15 }}
    >
      {children}
    </motion.div>
  );
}
